import { GroupBase, ValueContainerProps, components } from "react-select";
import { CustomSelectProps, SelectItem } from "../Select";
import { useCustomTranslation } from "../../../helpers/translateHelpers";

const ValueContainer = ({
  children,
  ...props
}: ValueContainerProps<SelectItem, false, GroupBase<SelectItem>>) => {
  const { tInput } = useCustomTranslation();

  const { multivalueTagLabelKey } = props.selectProps as CustomSelectProps;
  const selectedValues = props.getValue();
  const isMulti = !!props.selectProps.isMulti;
  const shouldCollapseTags =
    isMulti && selectedValues.length > 1;
  const shouldShowSingleAsText = isMulti && selectedValues.length === 1;

  const childrenArray = Array.isArray(children) ? children : [children];
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const input = childrenArray.at(-1);

  if (shouldCollapseTags) {
    return (
      <components.ValueContainer {...props}>
        <div className="bg-gray rounded-[4px] px-2 py-1 text-[14px]/[20px] font-medium tracking-[-0.14px]">
          {tInput(multivalueTagLabelKey ?? "selcted_items", {
            count: selectedValues.length,
          })}
        </div>
        {input}
      </components.ValueContainer>
    );
  }

  if (shouldShowSingleAsText) {
    return (
      <components.ValueContainer {...props}>
        <div className="truncate">{selectedValues[0]?.label}</div>
        {input}
      </components.ValueContainer>
    );
  }

  return (
    <components.ValueContainer {...props}>{children}</components.ValueContainer>
  );
};

export default ValueContainer;
